import React, { useEffect } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import BrandLogo from '../BrandLogo';
import FooterLinks from './FooterLinks';
import AppActions from '../../actions/app';
import TranslationUtil from '../../utils/TranslationUtil';
import { capitalizeBrand } from '../../utils/BrandUtil';

export const Footer = (props) => {
    const getPropsFromState = (state) => {
        const {
            brand, locale, footerLinks, getFooterLinks
        } = state.app;
        const { app } = state;
        const brandName = capitalizeBrand(brand);
        const translations = new TranslationUtil(app.translations, app.fallbackTranslations);
        const getTranslation = (suffix, params) => translations.getTranslation(`Vrbo.footer.${suffix}`, params);
        const compNotice = getTranslation('complianceNotice', { brandName });
        const earningsEst = getTranslation('earningsEst');
        const airbnbData = getTranslation('airbnb');
        const showAirBnbData = locale.display === 'en-us';

        return {
            brand,
            locale: locale.canonical,
            footerLinks,
            getFooterLinks,
            compNotice,
            earningsEst,
            airbnbData,
            showAirBnbData
        };
    };

    const {
        brand,
        locale,
        footerLinks,
        getFooterLinks,
        compNotice,
        earningsEst,
        airbnbData,
        showAirBnbData
    } = useSelector(getPropsFromState, shallowEqual);

    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(AppActions.getFooterLinks(brand, locale));
        return () => {};
    }, []);

    const { footerHtml, logo } = footerLinks || { };
    const { showCompliance } = props;

    return (
        <div className="ulx-footer">
            <div className="ulx-footer__center">
                {showCompliance && (
                    <div className="ulx-footer__compliance">
                        <p>
                            {`${compNotice}`}
                        </p>
                        <p>
                            {`${earningsEst}`}
                        </p>
                        {showAirBnbData && (
                            <p>
                                {`${airbnbData}`}
                            </p>
                        )}
                    </div>
                )}
                <div className="ulx-footer__content">
                    <div className="ulx-footer__logowrapper">
                        <BrandLogo logo={logo} callStatus={getFooterLinks} isFooter />
                    </div>
                    <div className="ulx-footer__linkswrapper">
                        <FooterLinks referrerBrand={brand} footerHtml={footerHtml} />
                    </div>
                </div>
            </div>
        </div>
    );
};

Footer.propTypes = {
    showCompliance: PropTypes.bool
};

Footer.defaultProps = {
    showCompliance: false
};


Footer.displayName = 'Footer';
export default Footer;
